import { useState, useRef, useEffect } from "react";

function useHover({ onHover, onLeave, enabled }) {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleMouseOver = () => {
   if ( enabled ) {
    setValue(true);
    if (onHover) {
      onHover();
    }
   }
  };
  const handleMouseOut = () => {
    if( enabled ) {
      if (onLeave) {
        console.log('leaving')
        onLeave();
      }
      setValue(false);
    }
  };

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener("mouseenter", handleMouseOver);
        node.addEventListener("mouseleave", handleMouseOut);

        return () => {
          node.removeEventListener("mouseenter", handleMouseOver);
          node.removeEventListener("mouseleave", handleMouseOut);
        };
      }
    },
    [ref.current] // Recall only if ref changes
  );

  return [ref, value];
}

export default useHover;
